/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_Modal as Modal,
  rec_React as React,
  rec_Ro as Ro,
  rec_SelectorMultiple as SelectorMultiple,
  rec_api as api,
  rec_ii as ii,
  rec_obtenerUsuario as obtenerUsuario,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function CerrarProyecto({ proyecto: e, onClose: t, onCerrado: n }) {
  let r = Go(),
    [i, a] = (0, React.useState)(`COMPLETADO`),
    [o, s] = (0, React.useState)(``),
    [c, l] = (0, React.useState)(``),
    [u, f] = (0, React.useState)(!1);
  async function p(t) {
    (t.preventDefault(), f(!0), l(``));
    try {
      (await api(`/proyectos/${e.id}/cerrar`, {
        method: `POST`,
        body: JSON.stringify({
          estado: i,
          nota: o,
          actorNombre: obtenerUsuario()?.nombre,
        }),
      }),
        i === `COMPLETADO`
          ? r.logro(`Proyecto terminado`, e.nombre)
          : r.info(`«${e.nombre}» quedó cancelado`),
        n());
    } catch (e) {
      (l(e.message), f(!1));
    }
  }
  return (
    <Modal
      titulo={`Terminar «${e.nombre}»`}
      onClose={t}
      children={
        <form
          onSubmit={p}
          className={`flex flex-col gap-3`}
          children={[
            <label
              className={`flex flex-col gap-1 text-xs text-(--text)`}
              children={[
                `¿Cómo termina?`,
                <SelectorMultiple
                  value={i}
                  onChange={a}
                  opciones={[
                    {
                      value: `COMPLETADO`,
                      label: `Se completó`,
                    },
                    {
                      value: `CANCELADO`,
                      label: `Se canceló`,
                    },
                  ]}
                />,
              ]}
            />,
            <label
              className={`flex flex-col gap-1 text-xs text-(--text)`}
              children={[
                `Cierre (opcional)`,
                <input
                  className={Lo}
                  value={o}
                  onChange={(e) => s(e.target.value)}
                  placeholder={`Resultado, acuerdos, qué quedó pendiente…`}
                />,
              ]}
            />,
            <p
              className={`text-xs text-(--text)`}
              children={`Después de esto el proyecto queda como registro: no se le agregan ni se le editan tareas.`}
            />,
            c && <p className={`text-sm text-(--error)`} children={c} />,
            <div
              className={`flex flex-col-reverse gap-2 sm:flex-row sm:justify-end`}
              children={[
                <button
                  type={`button`}
                  onClick={t}
                  className={zo}
                  children={`Volver`}
                />,
                <button
                  type={`submit`}
                  disabled={u}
                  className={Ro}
                  children={[
                    u &&
                      (0, JSXRuntime.jsx)(ii, {
                        className: `mr-1 inline h-4 w-4 animate-spin`,
                      }),
                    ` Terminar proyecto`,
                  ]}
                />,
              ]}
            />,
          ]}
        />
      }
    />
  );
}
